import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid';
import { map, get } from 'lodash';
import {
  ButtonToolbar,
  ToggleButtonGroup,
  ToggleButton,
  InputGroup,
  FormControl,
  Glyphicon
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const FieldFilter = ({
  search,
  type,
  types,
  onChangeSearch,
  onChangeType,
  clearFunc,
  canClear
}) => (
  <>
    <div className="tvt-report-builder__field-filter">
      <div className="tvt-report-builder__field-filter__title">
        Dimensions & Metrics{' '}
        {canClear && (
          <button className="clear-fields-button" onClick={clearFunc}>
            Clear all
          </button>
        )}
      </div>
      <InputGroup className="tvt-report-builder__field-filter__search">
        <InputGroup.Addon>
          <Glyphicon glyph="search" />
        </InputGroup.Addon>
        <FormControl
          type="text"
          placeholder="Search for Field Names"
          value={search}
          onChange={e => onChangeSearch(e.target.value)}
        />
        {get(search, 'length', 0) > 0 && (
          <button
            className="tvt-report-builder__field-filter__search-clear"
            onClick={e => onChangeSearch('')}
          >
            <FontAwesomeIcon icon="times-circle" />
          </button>
        )}
      </InputGroup>
    </div>
    <ButtonToolbar className="tvt-report-builder__sidebar-button-group">
      <ToggleButtonGroup
        type="radio"
        name="tvt-report-builder__field-filter__button-group"
        defaultValue={type.value}
        onChange={value => onChangeType(get(types, value, {}))}
      >
        {map(types, t => (
          <ToggleButton
            key={`tvt-report-builder__field-filter__button-${uuid()}`}
            value={t.value}
          >
            {t.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </ButtonToolbar>
  </>
);

const FieldTypeType = PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
});

FieldFilter.propTypes = {
  search: PropTypes.string.isRequired,
  type: FieldTypeType.isRequired,
  types: PropTypes.arrayOf(FieldTypeType).isRequired,
  onChangeSearch: PropTypes.func,
  onChangeType: PropTypes.func,
  clearFunc: PropTypes.func,
  canClear: PropTypes.bool
};

FieldFilter.defaultProps = {
  onChangeSearch: () => {},
  onChangeType: () => {},
  clearFunc: () => {},
  canClear: false
};

export default FieldFilter;
